/*jslint browser: true, unparam: true, nomen: true, maxerr: 50, indent: 3 */

/**
 * Free Text Search Module
 */
(function() {
   "use strict";
   var FreeTextSearch = function () {
      this.initialize = function () {
         this.showValidationErrors();
         this.expandLocationResults();
         this.singleLocationResultDisplay();
         //The results which are disabled must not be clickable
         $(".locationRow .disabled a").each(function() {
            $(this).attr("href", "javascript:void(0);");
            $(this).attr("onclick", "return false;");
         });
         
         // Fix IE7 missed redraw by forcing display change.
         if (!this.m_bIsBound) {
            this.m_bIsBound = true;
            portalAjax.bindLoadEvent($('#dropdownContent'), function (){ 
               var elDropdown = document.getElementById('dropdownContent');
               elDropdown.style.display = 'none'; 
               elDropdown.style.display = 'block'; 
            });
         }
         
         $(".locationResultsDiv, .propertyResultsDiv, .officeResultsDiv, .agentResultsDiv").on('hover', 
            function() {
            	if($(this).find('.freetextsearchLabelNoData').length == 0){
                   $(this).addClass('parentHover');	
            	}
            }, 
            function() {$(this).removeClass('parentHover');}
         );
      }

      /** 
       * Hide other sections for a single location result display
       */
      this.singleLocationResultDisplay = function () {
         var hasProperties = $("#hasProperties").val();
         var suggestType = $("#suggestType").val();
         if(suggestType.length > 0) {
            if(suggestType == 'SINGLE_LOCATION') {
               // Hide properties section only if there are none
               // Need to show MLS matched properties if any
               if(hasProperties != 'true') {
                  $("#propertyResultsDiv").hide();
               }               
               $("#officeResultsDiv").hide();
               $("#agentResultsDiv").hide();
            }
         }
      }

      /**
       * Add a class when the more location results are displayed
       */
      this.expandLocationResults = function () {
         var strShowMore = $("#showMore").val();
         if(strShowMore.length > 0 && strShowMore == 'L') {
            $(".freeTxtResults.location").addClass("megaextended");
         }
      }

      /**
       * Show the validation errors
       */
      this.showValidationErrors = function () {
         var count = $("#validationErrorCount").val(),
            errors = "";

         if(count > 0) {
            $("#searchValidationErrors .errordisplay").each(function () {
               var error = $(this).html();
               errors += error + "\r\n"
            });

            alert(errors);
         }
      }
      
      /**
       * Set the search rental flag.
       * 
       */
      this.searchRental = function() {
    	  $("#searchRental").val("Y");  
      };

      /**
       * Set the search open houses flag.
       * 
       */
      this.searchOpenHouses = function() {
    	  $("#searchOpenHouses").val("Y");  
      };
      
      /**
       * Set the search recently reduced flag.
       * 
       */
      this.searchRecentlyReduced = function() {
    	  $("#searchRecentlyReduced").val("Y");  
      };
      
      /**
       * Set the search newly listed flag.
       * 
       */
      this.searchNewlyListed = function() {
    	  $("#searchNewlyListed").val("Y");  
      };
      
      /**
       * Set the search foreclosures flag.
       * 
       */
      this.searchForeclosures = function() {
    	  $("#searchForeclosures").val("Y");  
      };
      
      /**
       * Google Analytics Tracking:
       * Exact Location Match
       * 
       */
      this.gaTrackExactLocationMatch = function(locationID, selectedLidType) {
	   	 if(locationID != null && locationID.length > 0 && selectedLidType != null && selectedLidType.length > 0) {
	   		 if(selectedLidType == 'C') {
	       	    Track.doEvent('FTS Exact', 'City', locationID);
	   		 } else if(selectedLidType == 'S') {
	   			Track.doEvent('FTS Exact', 'State', locationID);
	   		 } else if(selectedLidType == 'Z') {
	   			Track.doEvent('FTS Exact', 'Zip', locationID);
	   		 } else if(selectedLidType == 'N') {
	   			Track.doEvent('FTS Exact', 'County', locationID); 
	   		 } else if(selectedLidType == 'P' || selectedLidType == 'Q' || selectedLidType == 'R') {
	   			 Track.doEvent('FTS Exact', 'Neighborhood', locationID); 
	   		 }
	   	 }
      };      
      
      /**
       * Google Analytics Tracking:
       * Exact Office Match
       * 
       */
      this.gaTrackExactOfficeMatch = function(officeID) {
         if(officeID != null && officeID.length > 0) {
     	    Track.doEvent('FTS Exact', 'Office Name', officeID);
     	 }
      };
      
      /**
       * Google Analytics Tracking:
       * Exact Agent/Team Match
       * 
       */
      this.gaTrackExactAgentMatch = function(agentID, isTeam) {
    	  if(agentID != null && agentID.length > 0) {
    		  if(isTeam != null && isTeam == true) {
    		     Track.doEvent('FTS Exact', 'Team Name', agentID);
    		  } else {
    			 Track.doEvent('FTS Exact', 'Agent Name', agentID); 
    		  }
    	  }
      };      
      
      /**
       * Google Analytics Tracking:
       * Exact Property Match
       * 
       */
      this.gaTrackExactPropertyMatch = function(propertyID, isMLSSearch) {
    	  if(propertyID != null && propertyID.length > 0) {
    		  if(isMLSSearch != null && isMLSSearch == "true") {
    		     Track.doEvent('FTS Exact', 'Property MLS #', propertyID);
    		  } else {
    			 Track.doEvent('FTS Exact', 'Property Address', propertyID);
    		  }
    	  }    	  
      };
      this.gaTrackingExperiment = function(eventLabel) {
         //Check if homepage 
         if ($(document.body).hasClass("home")) {
            Track.doEvent('Homepage', 'Search Performed', eventLabel);
         }
      };

      /**
       * Property Search
       */
      this.propertySearch = function (locationLID, showMore, bEnterPressed) {
         this.gaTrackingExperiment('FTS Property Search');
         var searchText = $("#searchText").val(),
            e = $("#e").val(),
            priceFrom = $("#priceFrom").val(),
            priceTo = $("#priceTo").val(),
            bedroomsFrom = $("#bedroomsFrom").val(),
            bedroomsTo = $("#bedroomsTo").val(),  
            bathroomsFrom = $("#bathroomsFrom").val(),
            bathroomsTo = $("#bathroomsTo").val(),
            structureSizeFrom = $("#structureSizeFrom").val(),
            structureSizeTo = $("#structureSizeTo").val(); 
         
         var rental = $("#searchRental").val();
         var openhouses = $("#searchOpenHouses").val();
         var recentlyreduced = $("#searchRecentlyReduced").val();
         var newlylisted = $("#searchNewlyListed").val();
         var foreclosures = $("#searchForeclosures").val();
         
         //GA Tracking search filters
         if((priceFrom != null && priceFrom.length > 0) || (priceTo != null && priceTo.length > 0)) {
        	 Track.doEvent('Free Text Search', 'Search listings by price range');
         }
         if((bedroomsFrom != null && bedroomsFrom.length > 0) || (bedroomsTo != null && bedroomsTo.length > 0)) {
        	 Track.doEvent('Free Text Search', 'Search listings by beds');
         }
         if((bathroomsFrom != null && bathroomsFrom.length > 0) || (bathroomsTo != null && bathroomsTo.length > 0)) {
        	 Track.doEvent('Free Text Search', 'Search listings by baths');
         }
         if((structureSizeFrom != null && structureSizeFrom.length > 0) || (structureSizeTo != null && structureSizeTo.length > 0)) {
        	 Track.doEvent('Free Text Search', 'Search listings by square feet');
         }         

         if(bEnterPressed) {
            e = 1;
         }
         
         
         // Ajax call to get more 
         portalAjax.doViewEngineAjax(
            'FreeTextSearchListingsSearch',
            '/freetextsearch.c21',
            $.param({
               q: searchText,
               e: e,
               showMore: showMore,
               locationLID: locationLID,
               listtyperental: rental,
               listtypeopenhouses: openhouses,
               listtyperecentlyreduced: recentlyreduced,
               listtypenewlylisted: newlylisted,
               listtypeforeclosures: foreclosures,               
               priceFrom: priceFrom,
               priceTo: priceTo,
               bedroomsFrom: bedroomsFrom,
               bedroomsTo: bedroomsTo,
               bathroomsFrom: bathroomsFrom,
               bathroomsTo: bathroomsTo,
               structureSizeFrom: structureSizeFrom,
               structureSizeTo: structureSizeTo,   
               submitted: 'true'
            }),
            {
               cache: true
            }
         );
      };
      
      /**
       * Get more results of the type needed
       */
      this.showMore = function (searchType) {
         var searchText = $("#searchText").val(),
            enterKey = $("#e").val();
         
         if(searchType == null || searchType.length == 0) {
            searchType = 'NONE';
         }
         
         // Ajax call to get more 
         portalAjax.doViewEngineAjax(
            'FreeTextSearchShowMore',
            '/freetextsearch.c21',
            $.param({
               q: searchText,
               e: enterKey,
               showMore: searchType,
               submitted: 'true'
            }),
            {
               cache: true
            }
         );
      };

      /**
       * Get all results of the type needed
       */
      this.viewAll = function (searchType) {
         var searchText = $("#searchText").val(),
            e = $("#e").val();
         
         if(searchType.length == 0) {
            searchType = 'NONE';
         }
         
         // Ajax call to get more 
         portalAjax.doViewEngineAjax(
            'FreeTextSearchViewAll',
            '/freetextsearch.c21',
            $.param({
               q: searchText,
               e: e,
               viewAll: searchType,
               submitted: 'true'
            }),
            {
               cache: true
            }
         );
      };
   };

   window.freeTextSearch = new FreeTextSearch();
}());
